// extracted by mini-css-extract-plugin
export default {"project-main-layout":"ProjectMain_project-main-layout__RjoK1"};